import Gallery from '../../../Gallery';

import foto_1 from './foto_1.jpg'
import foto_2 from './foto_2.jpg'
import foto_3 from './foto_3.jpg'
import foto_4 from './foto_4.jpg'

const slides = [
  {
    src: foto_1,
    title: 'Slide Title One',
    description: 'Slide Description One\n\nthis is new line',
  },
  {
    src: foto_2,
    title: 'Slide Title Two',
    description: 'Slide Description Two',
  },
  {
    src: foto_3,
    title: 'Slide Title Three',
    description: 'Slide Description Three',
  },
  {
    src: foto_4,
    title: 'Slide Title Three',
    description: 'Slide Description Three',
  }
]

export default function Index() {
  // Extraer el ID del video del Short
  const videoId = 'jPJcXY8dWGk';
  const videoUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className='container'>

      
      <div className='mt-3'>
        <h3>Construcción muro de contención Abril 2026</h3>
        <p>
          COOPMULMAG reafirma su compromiso solidario
          Nos complace informar a nuestros asociados y a la comunidad que el Consejo Administrativo de COOPMULMAG aprobó y ejecutó la obra civil de mitigación en el barrio Mamatoco, Santa Marta, destinada a apoyar a sus asociados, cuyas viviendas resultaron afectadas por la ola invernal y el desbordamiento del río Manzanares.
        </p>
        <p>
          La intervención consistió en la construcción de un muro de contención y la recuperación de la vivienda familiar, con recursos provenientes del Fondo de Solidaridad de la Cooperativa.
          Este proyecto no solo garantiza condiciones seguras y dignas para la familia afectada, sino que también protege a la comunidad frente a futuros riesgos de erosión y desbordamiento.
          Con esta acción, COOPMULMAG reafirma su misión social y su compromiso con la solidaridad, la protección y el bienestar de sus asociados.
        </p>
      </div>

      
      <Gallery slides={slides} />

      {/* Video de YouTube embebido - formato vertical */}
      <div className='mt-4 mb-4 d-flex justify-content-center'>
        <div style={{ 
          maxWidth: '400px',  // Ancho máximo para formato vertical
          width: '100%',
          aspectRatio: '9 / 16',  // Proporción vertical (9:16 para Shorts)
          margin: '0 auto'
        }}>
          <iframe
            src={videoUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '12px'
            }}
          ></iframe>
        </div>
      </div>

    </div>
  )
}